import { Component, OnInit } from '@angular/core';
import {ProductsService} from '../../services/products.service';

@Component({
  selector: 'app-product-ranges',
  templateUrl: './product-ranges.component.html',
  styleUrls: ['./product-ranges.component.scss']
})
export class ProductRangesComponent implements OnInit {


    data = [];
    itemToDelete;
    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };
    params = {
        searchText: '',
        limit: 25,
        limits: [25, 50, 75, 100],
        page: 0,
        pages: 0,
        pageArray: [],
        totalRecords: 0,
        sort: 'product_range.id',
        sorts: [],
    };


    constructor(
        private productsService: ProductsService,
    ) {
    }

    ngOnInit(): void {
     this.findAll();

    }

    findAll() {
        this.productsService.getProductRanges().subscribe(data => {
            this.data = data.data;
        });
    }

    deleteConfirm(item) {
        this.itemToDelete = item;
        this.confirmationData.title = `Please confirm you would like to delete ${item.name}`;
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;
    }

    delete(e) {
        this.confirmationData.open = false;
        if (e.action) {
            this.productsService.deleteProductRange(this.itemToDelete.id).subscribe(data => {
                this.findAll();
            });
        }
    }

}
